import http from "../http-common";

class TrabajadorTraslado {

    create(data) {
        return http.post("/trabajadortraslado",data);
    }

    getAll() {
        return http.get("/trabajadortraslado");
    }

    getByID(id) {
        return http.get(`/trabajadortraslado/${id}`);
    }

    updateTrabajadorTraslado(id, data) {
        return http.put(`/trabajadortraslado/${id}`,data);
    }

    eliminarTrabajadorTraslado(id) {
        return http.delete(`/trabajadortraslado/${id}`);
    }
}

export default new TrabajadorTraslado();